import Box from "@/common/components/Box";
import { CopyButton } from "@/common/components/CopyButton";
import TextField from "@/common/components/TextField";
import { useCardWithSecureInformation } from "@/common/hooks/queries/useCardWithSecureInformation";
import { useCopyButton } from "@/common/hooks/useCopyButton";
import { formatCardNumber } from "@/common/utils/formatters";
import { CompanyEquipmentData } from "../../types/companyEquipments.type";
import { cardStatusTranslation } from "@/features/cards/constants/cardStatusTranslation.constant";
import ResumeItem from "@/common/components/ResumeItem";

interface EquipmentCardDetailsProps {
  equipment?: CompanyEquipmentData;
  operationKlassToCheckPermission?: string;
}

const EquipmentCardDetails = ({ equipment, operationKlassToCheckPermission }: EquipmentCardDetailsProps) => {
  const { control, copySuccess, copyFailed } = useCopyButton();

  const {
    mutate: personalCard,
    isPending: personalCardIsPending,
  } = useCardWithSecureInformation({
    onSuccess: (response) => copySuccess(response?.data?.data?.number),
    onError: copyFailed
  });

  const showPendingCard = equipment?.card?.status !== 'shipped' && equipment?.card?.status !== 'active'

  const cardToDisplay = showPendingCard ? equipment?.pending_card || equipment?.card : equipment.card;

  return (
    <Box className="flex flex-col gap-6 p-4">
      <div className="flex justify-between items-center">
        <p>Cartão frota</p>
        <p className="font-light text-yellow-400 italic">Via: {cardToDisplay?.copy_number}</p>
      </div>

      <div className="flex flex-col gap-3">
        <ResumeItem
          label="Status do cartão"
          value={cardToDisplay?.status && cardStatusTranslation[cardToDisplay?.status as keyof typeof cardStatusTranslation] || '--'}
        />

        <TextField
          disabled
          label="Código"
          className="grow"
          RightIcon={(!personalCardIsPending || !!cardToDisplay?.id) ? <CopyButton operationKlassToCheckPermission={operationKlassToCheckPermission} control={control} className="text-blue-800" /> : undefined}
          onIconClick={() => personalCard(cardToDisplay?.id!)}
          isLoading={personalCardIsPending}
          value={formatCardNumber(cardToDisplay?.last_four_digits || '')}
        />
      </div>
    </Box>
  );
};

export default EquipmentCardDetails;
